// add header bg on hover
const navElement = document.querySelector('.header-navs');
            const bodyElement = document.body;

            navElement.addEventListener('mouseenter', function() {
                bodyElement.classList.add('header-background');
            });

            navElement.addEventListener('mouseleave', function() {
                bodyElement.classList.remove('header-background');
            });

// custom weglot footer selector
$('.footer-weglot-mainmenu .lvl_0').click(function() {       
        $('.footer-weglot-submenu').toggle(); 
    });



$(document).ready(function() {
$('.disclosure .disclosure__button').click(function() {
  $('.CountryList.disclosure__list').toggle();
});
});

// cookie banner refresh

    function CookiebotCallback_OnLoad() {
        if (Cookiebot.changed) {
            document.location.reload();
        }
    }

    // Listen for the 'CookiebotOnAccept' event
    window.addEventListener('CookiebotOnAccept', function (e) {
        if (Cookiebot.consented) {
            CookiebotCallback_OnLoad();
        }
    }, false);
